













































import Vue from 'vue'
import * as R from 'ramda'
import { Component, Prop, Watch } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IAccountPropertyInput } from '@/modules/AccountAsset/interfaces/account-asset-form'
import { states } from '@/utils/us_states'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class AccountAssetFormProperty extends Vue {
  @Prop({ type: Object as () => IAccountPropertyInput }) value!: IAccountPropertyInput

  recordTypeIndex = -1
  states = states
  R = R

  get today () {
    return this.$moment().format('YYYY-MM-DD')
  }

  validate () {
    return true
  }
}
